export default __webpack_public_path__ + "static/media/maintenanceBackgroundMB.1f4f0de1.png";